import Vue from 'vue'
import Element from 'element-ui'
import './element-variables.scss'
import { VueEditor } from "vue2-editor";


// Element.Dialog.props.closeOnClickModal.default=false;   


Vue.use(Element)
Vue.component("VueEditor", VueEditor);

